import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Moment from "react-moment";
import { useTranslation } from "react-i18next";

import { createNote, deleteNote, getNotes } from "redux/actions/setNoteActions";
import { BackButton } from "components/BackButton";
import { Loader } from "components/Loader";
import { Layout } from "components/Layout";
import { CreateNote } from "components/note/CreateNote";
import { ShowNote } from "components/note/ShowNote";
import { SureAlert } from "components/SureAlert";
import close from "../static/img/ic-close.svg";

/**
 * @api {get} /notes?pupilId=pupilId заметки
 * @apiGroup profile
 * @apiName заметки
 *
 * @apiQuery {String} pupilId ID ученика
 *
 * @apiDescription <p>Страница создания и просмотра списка заметок</p>
 * <p>Компонент <code>NotesPage.js</code> <a href="../client/src/pages/NotesPage.js">ссылка на файл</a></p>
 */

export const NotesPage = () => {
    const dispatch = useDispatch();
    const { search } = useLocation();
    const { t, i18n } = useTranslation("notes");
    const [pupilId, setPupilId] = useState(null);
    const [note, setNote] = useState(null);
    const [isCreate, setIsCreate] = useState(false);
    const { notes } = useSelector((state) => state.note);
    const { loading } = useSelector((state) => state.app);
    const { role } = useSelector((state) => state.auth);

    const [isSureAlert, setIsSureAlert] = useState(false);
    const [currentNote, setCurrentAdvice] = useState();

    function onSendClick(id) {
        setCurrentAdvice(id);
        setIsSureAlert(true);
    }

    function onCloseClick() {
        setIsSureAlert(false);
        setCurrentAdvice();
    }

    const deleteHandler = async (currentNote) => {
        if (currentNote) {
            dispatch(deleteNote(currentNote));
        }
        onCloseClick();
    };

    useEffect(() => {
        const query = new URLSearchParams(search);
        const pupilId = query.get("pupilId");
        dispatch(getNotes(pupilId));
        setPupilId(pupilId);
    }, [dispatch, search]);

    const createHandler = async (form) => {
        dispatch(createNote({ ...form, pupilId }));
    };

    if (loading) return <Loader />;

    if (isCreate) {
        return <CreateNote closeHandler={() => setIsCreate(!isCreate)} createHandler={createHandler} />;
    }

    if (note) {
        return <ShowNote note={note} backHandler={() => setNote(null)} t={t} i18n={i18n} />;
    }

    return (
        <Layout>
            <div className="page">
                <header className="page__header">
                    <BackButton />
                    {role === "psych" && (
                        <button
                            onClick={() => setIsCreate(!isCreate)}
                            className=" icon-btn  page__icon-btn  page__icon-btn_right  icon-btn_add"
                        />
                    )}
                    <p className="page__title">{t("notes")}</p>
                </header>

                {role === "psych" && (
                    <button
                        onClick={() => setIsCreate(!isCreate)}
                        className="main-btn main-btn_yellow"
                        style={{ marginBottom: "1.5rem" }}
                    >
                        {t("create_note")}
                    </button>
                )}

                <div className="school-page__wrapper">
                    <div className="list" style={{ marginBottom: 0 }}>
                        {notes.slice().sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).map((note) => {
                            const max = 70;
                            return (
                                <div key={note._id} className="list__item-wrap">
                                    <p className="list__item-date">
                                        <Moment locale={i18n.language} format="DD MMM, YYYY">
                                            {note.createdAt}
                                        </Moment>
                                    </p>
                                    <div className="list__item" onClick={() => setNote(note)}>
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onSendClick(note._id);
                                            }}
                                            className="closeButton"
                                        >
                                            <img alt="" src={close} />
                                        </button>
                                        <p>{note.title}</p>
                                        {note.createdBy && role === "psych" && (
                                            <p style={{ fontSize: '13px', color: '#999', marginTop: '4px', marginBottom: '4px' }}>
                                                {t("author")}: {note.createdBy.surname} {note.createdBy.name}
                                            </p>
                                        )}
                                        <p className="list__desc">
                                            {note.text.length > max ? note.text.slice(0, max).concat("...") : note.text}
                                        </p>
                                    </div>
                                </div>
                            );
                        })}
                        {isSureAlert && (
                            <SureAlert
                                text="Вы действительно хотите удалить Заметку?"
                                submitText="Удалить"
                                handleClose={onCloseClick}
                                handleSubmit={() => deleteHandler(currentNote)}
                            />
                        )}
                    </div>
                </div>
            </div>
        </Layout>
    );
};
